import React, { Component } from 'react';
import { Link } from 'react-router-dom';

//HeaderData
import HeaderData from './header/HeaderData';

//Imagen PortaPrent
import Logo from '../../Img/logo/portaprent.svg';

// css
import './Menu.scss';

import {
    Collapse,
    Navbar,
    NavbarToggler,
    NavbarBrand
} from 'reactstrap';

const menu = {margin: 0, padding: 0-3,};
const item = {height:90, margin:0, padding:0,};

class Menu extends Component {
    constructor(props){
    super(props);
        this.toggle = this.toggle.bind(this);
        this.state= {
          isOpen:false,
          menuOption:true,
          opcionIcon:false,
          headerOpcion:'opcionFalse',
          headermenu:'menuBlack',
          logo:'menuLogo',
          btnmenu: false
        };
      }
      // headerOpcion = this.headerOpcion.bind(this);
      componentDidMount() {
        window.onscroll = () => {
          if (window.scrollY > 30)
            this.setState( prevState => {
              return{headermenu: 'menuBack', logo: 'menuLogo-', btnmenu: false }
            })
          else{
            this.setState(prevState => {
              return{headermenu: 'menutransparent', logo: 'menuLogo', btnmenu: true}
            })
          }
        };
      }
    toggle(){
      this.setState(prevState =>{
        return{isOpen: !this.state.isOpen}
      });
    }
    enuOption(){
      if(this.state.headerOpcion === 'opcionFalse'){
        this.setState(prevState =>{
          return{headerOpcion: 'opcionTrue', opcionIcon:true}
        })
        }else{
          this.setState(prevState =>{
            return{headerOpcion: 'opcionFalse', opcionIcon:false}
          })
      };
    }
  render() {
    return (
      <div>
        <HeaderData/>
        <div className={`header-menu ${this.state.headermenu}` }>
          <Navbar light expand="md" style={menu} >
            <NavbarBrand to="/" style={item}>
              <img alt="menu logo" src={Logo} className={`${this.state.logo}`  } />
            </NavbarBrand>
            <NavbarToggler onClick={this.toggle} />
            <Collapse isOpen={this.state.isOpen} navbar>
              {/* <div  className= {(this.state.menuOption ? 'menuOption ' : ' ') + " ml-auto navbar headerMenu" + `${this.state.headerOpcion}` }> */}
              <div  className={`mlauto navbar headerMenu ${this.state.headerOpcion}`  }>
                <Link className="Inicio" to="/" >Inicio</Link>
                <Link className="Quienes-Somos" to="/Quienes-Somos" >¿Quienes Somos? </Link>
                <Link className="Productos" to="/Productos" >Productos</Link>
                {/*}<Link className="Productos" to="/Productos" >Servicios</Link>*/}
                <Link className="Contactenos" to="/Contactenos" >Contactenos </Link>
              </div>
              <i onClick={()=> {this.enuOption()}} className={ 'iconMenu ' + (this.state.btnmenu? '' : 'btnmenu ') + (this.state.opcionIcon? ' fa-times-circle ': "far fa-align-justify ") + " menu fas fa-3x"}></i>
            </Collapse>
          </Navbar>
        </div>
      </div>
    );
  }
}

export default Menu;



// WEBPACK FOOTER //
// ./src/Components/menu/Menu.jsx